import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route: AnyRoute = createFileRoute("/app/product/$productId/edit/")({
  beforeLoad: async () => redirect({ to: `information` }),
})
